/** Backend onboarding OTP is 6 digits (OtpConstants.OTP_LENGTH=6, verified on
 * the branch feature/direct-website-onboarding). */
export const OTP_LENGTH = 6;

export const TOTAL_STEPS = 9;

export const STORAGE_KEYS = {
  draft: "@freemium_onboarding_draft",
  planActive: "@freemium_plan_active",
  properties: "@freemium_onboarding_properties",
} as const;

import { COLORS } from "./theme/tokens";

/** Back-compat color map for step components; values sourced from the
 * Figma-extracted tokens (theme/tokens.ts) — the single source of truth. */
export const WIZARD_COLORS = {
  p100: COLORS.p100,
  p200: COLORS.p200,
  p500: COLORS.primary,
  p600: COLORS.primaryHover,
  p700: COLORS.p700,
  bg: COLORS.pageBg,
  surface: COLORS.surface,
  text: COLORS.text,
  muted: COLORS.muted,
  muted2: COLORS.muted2,
  success: COLORS.success,
  successBg: "#DCFCE7",
  error: COLORS.error,
  errorBg: COLORS.errorBg,
} as const;

/** Site color swatches offered in S5 (from prototype). */
export const SITE_COLOR_SWATCHES = [
  "#5B2FF9",
  "#0F172A",
  "#0D7A5F",
  "#C2410C",
  "#1D4ED8",
  "#BE185D",
  "#7C3AED",
  "#374151",
] as const;

export const DEFAULT_SITE_COLOR = "#5B2FF9";

// Amenity options now come from the shared backend source
// (api/PropertyManagment/amenities) — see S8Properties / AddProperty. The old
// hardcoded AMENITY_SECTIONS list was removed per MS-427.

/**
 * Property HOUSE RULES — the 6 predefined, property-level rules. These stable
 * keys are persisted to PropertyDetails.HouseRules (comma-joined) and are the
 * ONLY rules dataset shown on the guest website. Keep in sync with the backend
 * guest catalog (MsoolGuest HouseRuleCatalog.cs) and the labels under
 * FREEMIUM_ONBOARDING.HOUSE_RULES.* in the dashboard i18n.
 *
 * They are intentionally disjoint from the Access-Guide "guidelines"
 * (src/pages/Messaging — template-level, sent only in the post-booking message,
 * never on the site). Do not reintroduce guideline items (cleanliness, turn off
 * lights, keep keys, smoking areas) here.
 */
export const HOUSE_RULES: { key: string; labelKey: string }[] = [
  { key: "no_smoking", labelKey: "FREEMIUM_ONBOARDING.HOUSE_RULES.NO_SMOKING" },
  { key: "pets", labelKey: "FREEMIUM_ONBOARDING.HOUSE_RULES.PETS" },
  { key: "quiet", labelKey: "FREEMIUM_ONBOARDING.HOUSE_RULES.QUIET" },
  { key: "no_parties", labelKey: "FREEMIUM_ONBOARDING.HOUSE_RULES.NO_PARTIES" },
  { key: "family_friendly", labelKey: "FREEMIUM_ONBOARDING.HOUSE_RULES.FAMILY_FRIENDLY" },
  { key: "no_unregistered_visitors", labelKey: "FREEMIUM_ONBOARDING.HOUSE_RULES.NO_UNREGISTERED_VISITORS" },
];

/** Backend caps (PropertyManagmentRepository.UploadPropertyImages): 12 images, 5 MB each. */
export const MAX_IMAGES_PER_PROPERTY = 12;
export const MAX_IMAGE_BYTES = 5 * 1024 * 1024;
